
export class User {
  id!: number;
  displayName!: string | null;
  email!: string;
  mobilePhone!: string | null;
  businessPhones!: string | null;
  first_name!: string | null;
  last_name!: string | null;
  jobTitle!: string | null;
  officeLocation!: string | null;
  preferredLanguage!: string | null;
  userPrincipalName!: string | null;
  intune_user_id!: string | null;
  ip_address!: string | null;
  user_agent!: string | null;
  created_at!: string;
  updated_at!: string;

  constructor(data: Partial<User>) {
    Object.assign(this, data);
  }

  getFullName(): string {
    const parts = [this.first_name, this.last_name].filter(Boolean);
    return parts.join(' ') || this.displayName || this.email;
  }

  getDisplayName(): string {
    return this.displayName || this.getFullName();
  }

}
